import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { $fetch } from 'utils/fetch'

export default function DeleteKnowledgeBase({ knowledgeBase, onSuccess, open, setOpen }) {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await $fetch(`/v1/knowledge/${knowledgeBase.id}`, {
        method: 'DELETE',
      })
      toast.success('Knowledge base deleted successfully')
      onSuccess()
    }
    catch (error) {
      console.error('Failed to delete knowledge base:', error)
      toast.error(error.message || 'Failed to delete knowledge base')
    }
    finally {
      setIsDeleting(false)
      setOpen(false)
    }
  }

  return (
    <Modal
      isOpen={open}
      onOpenChange={setOpen}
      size="md"
      classNames={{
        base: 'border-2 border-gray-200 shadow-none rounded-none',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-lg font-semibold">Delete Knowledge Base?</h3>
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-gray-600">
            This action cannot be undone. This will permanently delete the
            knowledge base "
            {knowledgeBase.name}
            " and remove all associated
            data.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="bordered"
            onPress={() => setOpen(false)}
            radius="none"
            className="border-gray-200"
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onPress={handleDelete}
            isLoading={isDeleting}
            radius="none"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
